var map = {
	"./bg-download.png": "./app/views/web/share/user/assets/bg-download.png",
	"./bg-top.png": "./app/views/web/share/user/assets/bg-top.png",
	"./bg1.png": "./app/views/web/share/user/assets/bg1.png",
	"./bg2.png": "./app/views/web/share/user/assets/bg2.png",
	"./bg3.png": "./app/views/web/share/user/assets/bg3.png",
	"./female.png": "./app/views/web/share/user/assets/female.png",
	"./ic_add.png": "./app/views/web/share/user/assets/ic_add.png",
	"./ic_arrow.png": "./app/views/web/share/user/assets/ic_arrow.png",
	"./ic_chat.png": "./app/views/web/share/user/assets/ic_chat.png",
	"./ic_feed_null.png": "./app/views/web/share/user/assets/ic_feed_null.png",
	"./ic_like.png": "./app/views/web/share/user/assets/ic_like.png",
	"./ic_live.png": "./app/views/web/share/user/assets/ic_live.png",
	"./kimy.png": "./app/views/web/share/user/assets/kimy.png",
	"./live.png": "./app/views/web/share/user/assets/live.png",
	"./male.png": "./app/views/web/share/user/assets/male.png",
	"./mico.png": "./app/views/web/share/user/assets/mico.png",
	"./micolite.png": "./app/views/web/share/user/assets/micolite.png",
	"./vico.png": "./app/views/web/share/user/assets/vico.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./app/views/web/share/user/assets sync recursive ^\\.\\/.*\\.png$";